import React from "react";
import { useIntl } from "react-intl";
import { AppContext } from "@lib/types/Context";
import { SharedPaymentHistory } from "@app/shared";

const CustomerPaymentHistories: React.FC = () => {
  const { messages } = useIntl();

  return (
    <SharedPaymentHistory
      context={AppContext.CUSTOMER}
      customTitle={messages["sidebar.customer.paymentHistory"] as string}
      tableProps={{
        mobileTableProps: {
          initialVisibleColumns: 5,
        },
      }}
    />
  );
};

export default CustomerPaymentHistories;
